// Angular
import { Injectable } from '@angular/core';
// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { forkJoin, of } from 'rxjs';
// RxJS
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

// CRUD
import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
// State
import { AppState } from '../../reducers';
import {
  BlacklistActionToggleLoading,
  BlacklistActionTypes,
  BlacklistCheck,
  BlacklistDelete,
  BlacklistPageLoaded,
  BlacklistPageRequested,
  BlacklistPageToggleLoading,
  BlacklistRemove,
  BLActionFail,
  BLActionRefresh,
  BLActionSuccess,
  CheckResult,
} from '../_actions/blacklist.actions';
// Services
import { BlacklistService } from '../_services/blacklist.service';

@Injectable()
export class BlacklistEffects {
  showPageLoadingDistpatcher = new BlacklistPageToggleLoading({
    isLoading: true,
  });
  hidePageLoadingDistpatcher = new BlacklistPageToggleLoading({
    isLoading: false,
  });

  showActionLoadingDistpatcher = new BlacklistActionToggleLoading({
    isLoading: true,
  });
  hideActionLoadingDistpatcher = new BlacklistActionToggleLoading({
    isLoading: false,
  });

  loadBlacklistPage$ = createEffect(() =>
    this.actions$.pipe(
      ofType<BlacklistPageRequested>(
        BlacklistActionTypes.BlacklistPageRequested
      ),
      mergeMap(({ payload }) => {
        this.store.dispatch(this.showPageLoadingDistpatcher);
        const requestToServer = this.bls.findBlacklists(payload.page);
        const lastQuery = of(payload.page);
        return forkJoin(requestToServer, lastQuery);
      }),
      map(response => {
        const result: QueryResultsModel = response[0];
        const lastQuery: QueryParamsModel = response[1];
        return new BlacklistPageLoaded({
          blacklists: result.items,
          totalCount: result.totalCount,
          page: lastQuery,
        });
      })
    )
  );

  deleteBlacklist$ = createEffect(() =>
    this.actions$.pipe(
      ofType<BlacklistDelete>(BlacklistActionTypes.BlacklistDelete),
      map(action => action.payload),
      tap(() => this.store.dispatch(this.showPageLoadingDistpatcher)),
      switchMap(payload =>
        this.bls.removeBlacklist(payload.blacklist.id).pipe(
          switchMap(() => [
            new BlacklistRemove({ blacklist: payload.blacklist }),
            new BLActionSuccess({ result: `Η εγγραφή διαγράφηκε επιτυχώς` }),
            new BLActionRefresh({ result: true }),
          ]),
          catchError(err => [new BLActionFail({ result: err })])
        )
      ),
      switchMap(res => [res, this.hidePageLoadingDistpatcher])
    )
  );

  checkBlacklist$ = createEffect(() =>
    this.actions$.pipe(
      ofType<BlacklistCheck>(BlacklistActionTypes.BlacklistCheck),
      map(action => action.payload),
      switchMap(payload =>
        this.bls.checkBlacklist(payload.data).pipe(
          switchMap(res => [new CheckResult({ result: res })]),
          catchError(err => [new BLActionFail({ result: err })])
        )
      ),
      switchMap(res => [res])
    )
  );

  constructor(
    private actions$: Actions,
    private bls: BlacklistService,
    private store: Store<AppState>
  ) {}
}
